// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__35xVB","container":"styles_container__wG3Fc","iconButton":"styles_iconButton___Q1z4"};